export const getTileUrlTemplate = (
    row: any,  // 1
    stacUrl: string, // 2
    collectionId: string, // 3 
    footprintProperty: string, // 4 
    startTime: string, // 5
    endTime: string, // 6
    dateDisplayResolution: string, // 7 
    _caller: string = "unknown", // 8
    horizonSelected:string | null, // 9
    minMaxContext:string = "global", // 10
    seasonYear:string = "unknwown" // 11
  ) => {
  console.log("E021524 getTileUrlTemplate row", row)
  /*console.log("E021524 getTileUrlTemplate minMaxContext", minMaxContext)
  console.log("B121423 _caller", _caller)
  console.log("B121423 seasonYear", seasonYear)*/
  const stacUrlEnc = encodeURIComponent(stacUrl);
  const collectionIdEnc = encodeURIComponent(collectionId);
  //console.log("A060324 startTime", startTime)
  //console.log("A060324 endTime", endTime)
  var minDateFudged = startTime;
  var maxDateFudged = endTime;

  if (dateDisplayResolution === 'year') {
    maxDateFudged = `${new Date(endTime).getUTCFullYear()}-12-31`;
  }
  if (dateDisplayResolution === 'day') {
    var minDate2: any = new Date(startTime);
    var maxDate2: any = new Date(endTime);
    var minDaysSinceEpoch2 = Math.floor(minDate2 / 8.64e7) - 2;
    var maxDaysSinceEpoch2 = Math.floor(maxDate2 / 8.64e7) + 2;

    minDateFudged = convertFromEpoch(minDaysSinceEpoch2);
    maxDateFudged = convertFromEpoch(maxDaysSinceEpoch2);
  }

  let timeRange = encodeURIComponent(`${minDateFudged}/${maxDateFudged}`);
  /*console.log("AAA012524 _caller", _caller)
  console.log("AAA012524 row", row)
  console.log("AAA053023 startTime", startTime)
  console.log("AAA053023 endTime", endTime)
  console.log("AAA053023 stacUrl", stacUrl)*/
  
  //console.log("X110822 row.collection_id", row.collection_id)
  if (_caller === "template-seasonrange"){
    timeRange = encodeURIComponent(`${startTime}/${endTime}`);
  }
  if (_caller === "template-singledate"){
    timeRange = encodeURIComponent(`${maxDateFudged}`);
  }
  if (_caller === "template-singledate-p1"){
    //timeRange = encodeURIComponent(`${convertFromEpoch(Math.floor(maxDate2 / 8.64e7) + 1)}`);
    timeRange = encodeURIComponent(`${endTime}`); 
  }
  //console.log("A060324 timeRange", timeRange)
  //console.log("A060324 maxDate2", maxDate2)
  let _colorRamp = row.color_ramp ? (`&color_ramp=` + encodeURIComponent(row.color_ramp)) : ``;
  let _colorMap = row.color_map ? (`&color_map=` + encodeURIComponent(row.color_map)) : ``;
  let _stacQueryPrefix = row.stac_query_prefix;
  let _tileServer = row.tile_server;
  let _jq = row.jq ? (`&jq=` + encodeURIComponent(row.jq)) : ``;
  if (row.title === "Potassium"){
    console.log("A030725 row", row)
  }
  let _globalMin = minMaxContext == "global"
    ? (row.global_min || row.global_min === 0) ? (`&global_min=` + encodeURIComponent(row.global_min)) : ``
    : (row.field_min || row.field_min === 0) ? (`&global_min=` + encodeURIComponent(row.field_min)) : ``;
  let _globalMax = minMaxContext == "global"
    ? row.global_max ? (`&global_max=` + encodeURIComponent(row.global_max)) : ``
    : row.field_max ? (`&global_max=` + encodeURIComponent(row.field_max)) : ``;
  console.log("A121324 minMaxContext", minMaxContext)
  console.log("A121324 row.expr", row.expr)
  console.log("A121324 row.field_min", row.field_min)
  console.log("A121324 row.field_max", row.field_max)
  let _expr = minMaxContext == "global"
    ? row.expr ? (`&expr=` + encodeURIComponent(row.expr.replaceAll('{id}', horizonSelected))) : ``
    : row.field_min === 0 // -1 <-- If i make this condition always false, then the porassium layer will display with better color breaks.
      ? `&expr=` + encodeURIComponent(`(${horizonSelected} - ${row.field_min })/${1 - row.field_min}`) // NG: If the minimum is 0 then set the expression max value to 1 (or 100 or whatever, anything will work really)
      : row.field_min === 100
        ? `&expr=` + encodeURIComponent(`(${horizonSelected} - ${0})/${row.field_max - 0}`) // NG: If the minimum is 100 then set the expression for the min value to 0
        : `&expr=` + encodeURIComponent(`(${horizonSelected} - ${row.field_min })/${row.field_max - row.field_min}`) // original logic before 12/13/24

  // looking for {a-e} format
  const regex = /{([a-z])-([a-z])}/g;

  let matches = regex.exec(_tileServer);

  if (!matches || matches.length != 3) {
    return [`${_tileServer}/stac/{z}/{x}/{y}?url=${stacUrlEnc}${_colorRamp}${_colorMap}&datetime=${timeRange}&${_stacQueryPrefix}=${collectionIdEnc}${_jq}${_globalMin}${_globalMax}${_expr}`];
  }

  const token = matches[0];
  const start = matches[1];
  const end = matches[2];

  let urls = [];

  for (let i = start.charCodeAt(0); i <= end.charCodeAt(0); i++) {
    let server = _tileServer.replace(token, String.fromCharCode(i));
    if (server.substring(server.length - 1) == "/") {
      server = server.substring(0, server.length - 1);
    }
    //console.log("012534 row", row)
    if(row.collection_id === "\"naip\""){ // We will only display one date of NAIP for now. Remove the datetime parameter so that new tiles are not solicited.
      //urls.push(`${server}/stac/{z}/{x}/{y}?url=${stacUrlEnc}${_colorRamp}${_colorMap}&${_stacQueryPrefix}=${collectionIdEnc}${_jq}${_globalMin}${_globalMax}${_expr}`);
      urls.push(`${server}/stac/{z}/{x}/{y}?url=${stacUrlEnc}&datetime=../${seasonYear}-12-31T00:00:00Z&collections=[\"naip\"]`);
      //urls.push(`${server}/stac/{z}/{x}/{y}?url=${stacUrlEnc}${_colorRamp}${_colorMap}&${_stacQueryPrefix}=${collectionIdEnc}${_jq}${_globalMin}${_globalMax}${_expr}`);
    }else{
      urls.push(`${server}/stac/{z}/{x}/{y}?url=${stacUrlEnc}${_colorRamp}${_colorMap}&datetime=${timeRange}&${_stacQueryPrefix}=${collectionIdEnc}${_jq}${_globalMin}${_globalMax}${_expr}`);
    }
  }
  //console.log("E021524 urls", urls)
  return urls;
}

export const convertFromEpoch = (daysFromEpoch: any) => {

  //console.log("A060324 convertFromEpoch daysFromEpoch", daysFromEpoch)
  if (typeof daysFromEpoch === 'string') {
    return daysFromEpoch;
  }
  var valueFromEpoch = ((daysFromEpoch) * 8.64e7)
  //console.log("A060324 convertFromEpoch valueFromEpoch", valueFromEpoch)
  var dateFromEpoch = new Date(valueFromEpoch);
  //console.log("A060324 convertFromEpoch dateFromEpoch", dateFromEpoch)
  var ye = dateFromEpoch.toLocaleDateString("en-US", { year: 'numeric' });
  var mo = dateFromEpoch.toLocaleDateString("en-US", { month: 'numeric' });
  var da = dateFromEpoch.toLocaleDateString("en-US", { day: 'numeric' });
  if (mo.length < 2) {
    mo = "0" + mo;
  }
  if (da.length < 2) {
    da = "0" + da;
  }
  var dateFormatted = `${ye}-${mo}-${da}`;

  return dateFormatted;
}